import { all, call, fork, put, takeLatest, select } from "redux-saga/effects";
import WebhookService from "../../services/Webhook";
import {
  WEBHOOK_LIST_ALL,
  WEBHOOK_CREATE,
  WEBHOOK_DELETE,
  WEBHOOK_UPDATE
} from "../../constants/ActionTypes";

import {
  webhookListSuccess,
  webhookListError,
  webhookListAll,
  webhookModalVisible,
  webhookCreateSuccess,
  webhookCreateError,
  webhookDeleteSuccess,
  webhookDeleteError,
  webhookUpdateSuccess,
  webhookUpdateError,
  webhoookComponentVisible
} from "../actions/Webhook";
import { notificationMessage } from "../reducers/FeedbackMessage";

const getCompanyFilter = state => state.filter && state.filter.companyId;

const listAllWebhookRequest = id => WebhookService.listAllWebhooks(id);

const createWebhookRequest = data => WebhookService.createWebhook(data);

const deleteWebhookRequest = id => WebhookService.deleteWebhook(id);

const updateWebhookRequest = data => WebhookService.updateWebhook(data);

function* listAllWebhook({ payload }) {
  try {
    yield put(webhoookComponentVisible(true));
    const actions = yield call(listAllWebhookRequest, payload);
    yield put(webhoookComponentVisible(false));
    yield put(webhookListSuccess(actions));
  } catch (error) {
    yield put(webhoookComponentVisible(false));
    yield put(webhookListError());
  }
}

function* createWebhook({ payload }) {
  try {
    const webhook = yield call(createWebhookRequest, payload);
    if (webhook) {
      yield put(webhookCreateSuccess(webhook));
      yield put(webhookModalVisible(false));
      yield put(
        notificationMessage("notifications.action.create.success", "success")
      );
      try {
        const companyId = yield select(getCompanyFilter);
        yield put(webhookListAll(companyId));
      } catch (error) {
        yield put(
          notificationMessage("notifications.action.list.error", "error")
        );
      }
    } else {
      yield put(
        notificationMessage("notifications.action.create.error", "error")
      );
    }
  } catch (error) {
    yield put(webhookCreateError());
    yield put(
      notificationMessage("notifications.action.create.error", "error")
    );
  }
}

function* updateWebhook({ payload }) {
  try {
    const webhook = yield call(updateWebhookRequest, payload);
    if (webhook) {
      yield put(webhookUpdateSuccess());
      yield put(webhookModalVisible(false));
      yield put(
        notificationMessage("notifications.action.update.success", "success")
      );
      try {
        const companyId = yield select(getCompanyFilter);
        yield put(webhookListAll(companyId));
      } catch (error) {
        yield put(
          notificationMessage("notifications.action.list.error", "error")
        );
      }
    } else {
      yield put(
        notificationMessage("notifications.action.update.error", "error")
      );
    }
  } catch (error) {
    yield put(webhookUpdateError());
    yield put(
      notificationMessage("notifications.action.update.error", "error")
    );
  }
}

function* deleteWebhook({ payload }) {
  try {
    yield call(deleteWebhookRequest, payload);
    yield put(webhookDeleteSuccess());
    yield put(
      notificationMessage("notifications.action.delete.success", "success")
    );
    try {
      const companyId = yield select(getCompanyFilter);
      yield put(webhookListAll(companyId));
    } catch (error) {
      yield put(
        notificationMessage("notifications.action.list.error", "error")
      );
    }
  } catch (error) {
    yield put(webhookDeleteError());
    yield put(
      notificationMessage("notifications.action.delete.error", "error")
    );
  }
}

export function* webhookListAllSaga() {
  yield takeLatest(WEBHOOK_LIST_ALL, listAllWebhook);
}

export function* createWebhookSaga() {
  yield takeLatest(WEBHOOK_CREATE, createWebhook);
}

export function* deleteWebhookSaga() {
  yield takeLatest(WEBHOOK_DELETE, deleteWebhook);
}

export function* updateeWebhookSaga() {
  yield takeLatest(WEBHOOK_UPDATE, updateWebhook);
}

export default function* rootSaga() {
  yield all([
    fork(webhookListAllSaga),
    fork(createWebhookSaga),
    fork(deleteWebhookSaga),
    fork(updateeWebhookSaga)
  ]);
}
